import {
  getDay,
  isBefore,
  set
} from "date-fns";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { useLocalStorage } from "../../../hooks";
import * as dashboardActions from "../../../redux/reducers/dashboardReducer";
import * as userActions from "../../../redux/reducers/userReducer";
import { dashboardState } from "../../../redux/reducers/dashboardReducer";

import GeneralTab from "./GeneralTab";
import PoliciesTab from "./PoliciesTab";
import PricingTab from "./PricingTab";
import ReviewPublishTab from "./ReviewPublishTab";
import ScheduleTab from "./schedule/ScheduleTab";

import { classNames, minutesToDuration } from "../../../helpers";


import { TabPanel } from "@headlessui/react";
import moment from "moment";
import payment from "../../../assets/Payment.svg";
import { TwButton, TwContainer, TwMainLayout, TwNavigationGuard, TwTabContainer } from "../../../components/tailwind";
import { useToast } from "../../../provider/ToastProvider";
import { loadingState, setActionLoading, setGlobalLoading } from "../../../redux/reducers/loadingReducer";
import { userState } from "../../../redux/reducers/userReducer";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForEvent, getUrlForUsers } from "../../../utils/confighelpers";
import AddonsTab from "./AddonsTab";
import { useTranslation } from "react-i18next";

export default function AddNewEvent({ navigation, profileFor }) {
  const { t, i18n } = useTranslation();
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const [userToken] = useLocalStorage("userToken");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const dashboardReduxState = useSelector(dashboardState);
  const loadingReduxState = useSelector(loadingState);
  const userReduxState = useSelector(userState);
  const [tabCurrentState, setTabCurrentState] = React.useState('1');
  const [newDraftEventData, setNewDraftEventData] = useLocalStorage("newDraftEventData");
  const [shouldBlock, setShouldBlock] = React.useState(false);

  if (!userToken || userToken.length < 1) {
    navigate("/", { replace: true });
  }

  // const title = " Add New " + (location.state ? location.state.title : "")
  const title = " Add New " + profileFor.toLowerCase().replace(/\b[a-z]/g, function (letter) {
    return letter.toUpperCase();
  })
  const handleTabChange = (event, newValue) => {
    setTabCurrentState(newValue);
  };

  const handleFormValueChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  // const edit = location.state !== null && location.state?.from && location.state?.from == "duplicateEvent" ? location.state?.from : "drafted";
  const edit = location.state !== null && location.state?.from && location.state?.from == "duplicateEvent" ? location.state?.from : null;
  // const draftData = newDraftEventData && Object.keys(newDraftEventData).length > 0 ? newDraftEventData : {};
  const draftData = {};
  const editData = edit == "drafted" && Object.keys(draftData).length > 0 ? draftData : (edit == "duplicateEvent" ? location.state?.eventData : {});
  const durationObj = minutesToDuration(edit && editData.duration ? editData.duration : 60);
  const classBodyData = {
    photo: edit ? (editData?.photo || editData.eventPhoto || "") : "",
    eventCategory: edit && edit !== "drafted"
      ? { _id: editData.eventCategory, name: "" }
      : {},
    categories: edit && edit !== "drafted"
      ? { _id: editData.catId, catName: "" }
      : {},
    eventName: edit ? editData.eventName : "",
    tagLine: edit ? editData.tagLines : "",
    classDescription: edit ? (editData?.classDescription || editData?.description || "") : "",
    duration: durationObj,
    durationstring: edit ? `${durationObj.hours} hr ${durationObj.mins} min` : "0 hr 15 min",
    sessions: "",
    whatToCarry: edit ? editData.whatToCarry : "",
    freeCancellation: edit && editData?.freeCancellation ? editData.freeCancellation
      : editData.eventCancelationPolicy?.isEnabled
        ? true
        : false,
    cancellationPeriod: edit && editData?.cancellationPeriod ? editData.cancellationPeriod : (edit
      ? editData.eventCancelationPolicy?.minutes === 60
        ? "1hr"
        : editData.eventCancelationPolicy?.minutes === 1440
          ? "24hrs"
          : editData.eventCancelationPolicy?.minutes === 2880
            ? "48hrs"
            : editData.eventCancelationPolicy?.minutes === 10080
              ? "1 week"
              : ""
      : "24hrs"),
    cancellationCharge: 0,
    inviteCodeOnlyBooking: edit && editData?.inviteCodeOnlyBooking ? editData.inviteCodeOnlyBooking : ((edit && editData.isPrivate ? true : false)),
    // paymentAtVenue: edit ? editData.paymentAtVenue : false,
    orderLimit: edit ? (editData.orderLimit ? true : false) : false,
    maxTicketsPerOrder: edit && editData?.maxTicketsPerOrder ? editData.maxTicketsPerOrder : 1000,
    paymentAtVenue: false,
    // eventPricingList: edit && editData?.eventPricingList ? editData.eventPricingList : [],
    // addonsPricingList: edit && editData?.addonsPricingList ? editData.addonsPricingList : [],
    eventPricingList: edit && edit == "duplicateEvent" && location.state?.eventScheduleData?.eventPricingList ? location.state?.eventScheduleData.eventPricingList : [],
    addonsPricingList: edit && edit == "duplicateEvent" && location.state?.eventScheduleData?.addonsPricingList ? location.state?.eventScheduleData.addonsPricingList : [],
  };
  const [formValues, setFormValues] = React.useState(classBodyData);
  const [formScheduleValues, setFormScheduleValues] = React.useState(edit == "duplicateEvent" ? {
    // ...location.state?.eventScheduleData,
    // startDate: moment(location.state?.eventScheduleData?.eventDate).format("YYYY-MM-DD HH:mm"),
    duration: location.state?.eventScheduleData?.duration,
    startDate: moment(location.state?.eventScheduleData?.eventDate),
    startTime: moment(location.state?.eventScheduleData?.eventDate),
    // endDateTime: moment(location.state?.eventScheduleData?.eventDate).add(location.state?.eventScheduleData?.duration, "minutes").format("YYYY-MM-DD"),
    // endTime: moment(location.state?.eventScheduleData?.eventDate).add(location.state?.eventScheduleData?.duration, "minutes").format("HH:mm"),

    location: location.state?.eventScheduleData.location
  } : (edit == "drafted" ? { ...(editData?.eventScheduleData || {}) } : {}));
  const [defaultScheduleData, setDefaultScheduleData] = React.useState({});
  const [isSubmitting, setSubmitting] = React.useState(false);
  const [formErrors, setFormErrors] = React.useState({});
  const [scheduleDateTime, setScheduleDateTime] = React.useState({
    scheduleStartDateTime: moment().unix(), scheduleEndDateTime: moment().unix(),
  });

  const defaultDataSaveProgress = {
    isStartSubmiting: false,
    isButtonShow: true,
    createEvent: false,
    createPricing: false,
    createSchedule: false,
    changePublishStatus: false,
    creatingBookingLink: false,
    bookingLink: "https://Bookzyme.com/",
  };
  const [dataSaveProgress, setDataSaveProgress] = React.useState(defaultDataSaveProgress);

  const saveClass = async (isPublish) => {
    setSubmitting(true);

    const errors = {};
    if (!formValues.photo) {
      errors.photo = t("errors.required");
    }
    if (!Object.keys(formValues.eventCategory).length) {
      errors.eventCategory = t("errors.required");
    }
    if (!Object.keys(formValues.categories).length) {
      errors.categories = t("errors.required");
    }
    if (!formValues.eventName) {
      errors.eventName = t("errors.required");
    }
    if (!formValues.classDescription) {
      errors.classDescription = t("errors.required");
    } else if (formValues.classDescription.length < 5) {
      errors.classDescription = t("errors.aboutusMinLength", { businessName: title });
    }
    if (!formValues.duration) {
      errors.duration = t("errors.required");
    }
    if (formValues.freeCancellation) {
      if (!formValues.cancellationPeriod) {
        errors.cancellationPeriod = t("errors.required");
      }
    }
    if (!formValues.maxTicketsPerOrder || formValues.maxTicketsPerOrder <= 0) {
      errors.maxTicketsPerOrder = t("errors.required");
    }
    if (formValues.maxTicketsPerOrder % 1 !== 0) {
      errors.maxTicketsPerOrder = t("errors.decimalValueOnly");
    }
    setFormErrors({ ...errors });
    if (Object.keys(errors).length > 0) {
      setSubmitting(false);
      addErrorToast(t("errors.validationGeneralError"), { hideAfter: 3 });
      return;
    }

    if (scheduleSubmit() === false) {
      return;
    }

    let startDate = formScheduleValues.startDate?.toDate && typeof formScheduleValues.startDate.toDate == "function" ? formScheduleValues.startDate.toDate() : formScheduleValues.startDate
    let endDate = formScheduleValues.endDate?.toDate && typeof formScheduleValues.endDate.toDate == "function" ? formScheduleValues.endDate.toDate() : formScheduleValues.endDate
    let startTime = formScheduleValues.startTime?.toDate && typeof formScheduleValues.startTime.toDate == "function" ? formScheduleValues.startTime.toDate() : formScheduleValues.startTime
    startTime = moment(moment(startDate).format("YYYY-MM-DD") + " " + moment(startTime).format("HH:mm"), "YYYY-MM-DD HH:mm")
    let endTime = formScheduleValues.endTime?.toDate && typeof formScheduleValues.endTime.toDate == "function" ? formScheduleValues.endTime.toDate() : formScheduleValues.endTime
    // endTime = moment(moment().format("YYYY-MM-DD") + "" + moment(endTime).format("HH:mm"), "YYYY-MM-DD HH:mm")
    let endDateTime = formScheduleValues.endDateTime?.toDate && typeof formScheduleValues.endDateTime.toDate == "function" ? formScheduleValues.endDateTime.toDate() : formScheduleValues.endDateTime
    endTime = moment(moment(endDateTime).format("YYYY-MM-DD") + " " + moment(endTime).format("HH:mm"), "YYYY-MM-DD HH:mm")

    var duration = moment.duration(moment(endTime).diff(moment(startTime)));
    var minutes = duration.asMinutes();
    const durationSplit = formValues.durationstring.split(" ");
    // const durationInNum = Number(durationSplit[0]) * 60 + Number(durationSplit[2]);
    const durationInNum = minutes;


    // cancellationCharge may be a number (default/initial state) or a string
    // typed with a comma decimal — normalise both before parsing.
    const cancellationChargeValue =
      parseFloat(String(formValues.cancellationCharge ?? 0).replace(",", ".")) || 0;

    const cancelationPolicy =
      formValues.cancellationPeriod === "1hr"
        ? { isEnabled: true, text: "1 hour", minutes: 60, cancellationCharge: cancellationChargeValue }
        : formValues.cancellationPeriod === "24hrs"
          ? { isEnabled: true, text: "24 hours", minutes: 1440, cancellationCharge: cancellationChargeValue }
          : formValues.cancellationPeriod === "48hrs"
            ? { isEnabled: true, text: "48 hours", minutes: 2880, cancellationCharge: cancellationChargeValue }
            : formValues.cancellationPeriod === "1 week"
              ? { isEnabled: true, text: "1 week", minutes: 10080, cancellationCharge: cancellationChargeValue }
              : null;

    let body = {
      dataFor: userReduxState.businessType,
      eventCategory: formValues.eventCategory._id,
      catId: formValues.categories._id,
      eventType: formValues.categories.name,
      eventName: formValues.eventName,
      description: formValues.classDescription,
      tagLines: formValues.tagLine,
      duration: durationInNum,
      whatToCarry: formValues.whatToCarry,
      eventPhoto: formValues.photo,
      isPrivate: formValues.inviteCodeOnlyBooking,
      eventCancelationPolicy: formValues.freeCancellation
        ? cancelationPolicy
        : { isEnabled: false },
      maxTicketsPerOrder: parseInt(formValues.maxTicketsPerOrder),
      paymentAtVenue: formValues.paymentAtVenue,
      isPublic: true,
    };

    if (!edit || (edit && (edit === "duplicateEvent" || edit === "drafted"))) {
      //add
    } else {
      body = {
        eventId: editData._id,
      };
    }
    let config = {};
    if (!edit || (edit && (edit === "duplicateEvent" || edit === "drafted"))) {
      config = {
        method: "post",
        // url: `${getUrlForStage()}schools/setClass`,
        url: `${getUrlForEvent()}add`,
        data: body,
      };
    } else {
      config = {
        method: "put",
        // url: `${getUrlForStage()}schools/updateSetClass`,
        url: `${getUrlForEvent()}update`,
        data: body,
      };
    }
    // return;

    /* {
      isStartSubmiting: 0,
      createEvent: 0,
      createPricing: 0,
      createSchedule: 0,
      changePublishStatus: 0,
      creatingBookingLink: 0,
    } */
    setDataSaveProgress((prevValues) => ({
      ...prevValues,
      isStartSubmiting: true,
      isButtonShow: false,
    }));

    // dispatch(setGlobalLoading(true));
    dispatch(setActionLoading(true));
    const request = await axiosInstance(config);
    dispatch(setActionLoading(false));
    dispatch(setGlobalLoading(false));

    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        setShouldBlock(false)
        let eventData = request.data.data;
        if (profileFor === "course") {
          dispatch(dashboardActions.setNewCourseDetails(formValues));
          dispatch(dashboardActions.setNewCourseRes(request.data.data));
          dispatch(dashboardActions.setCourseToSchedule(request.data.data));
        } else {
          dispatch(dashboardActions.setNewClassDetails(formValues));
          dispatch(dashboardActions.setNewClassRes(request.data.data));
          dispatch(dashboardActions.setClassToSchedule(request.data.data));
        }
        setSubmitting(false);
        setDataSaveProgress((prevValues) => ({
          ...prevValues,
          createEvent: true,
          createPricing: true,
        }));

        /** **/

        // let scheduleBody = { ...formScheduleValues }
        let scheduleBody = { ...scheduleSubmit() }
        scheduleBody.eventId = eventData._id;
        scheduleBody.isPublished = true;
        scheduleBody.eventStatus = isPublish ? "Published" : "Draft";
        const scheduleConfig = {
          method: "post",
          // url: `${getUrlForStage()}schools/scheduleTheClass`,
          url: `${getUrlForEvent()}schedule/create`,
          data: scheduleBody,
        };
        // dispatch(setGlobalLoading(true));
        dispatch(setActionLoading(true));
        const scheduleRequest = await axiosInstance(scheduleConfig);
        dispatch(setActionLoading(false));
        dispatch(setGlobalLoading(false));
        if (scheduleRequest.data.statusCode !== 200) {
          addErrorToast(scheduleRequest.data.message);
          setSubmitting(false);
          setDataSaveProgress((prevValues) => ({
            ...prevValues,
            isButtonShow: true,
          }));
          return;
        }
        if (scheduleRequest.data.statusCode === 200) {
          setShouldBlock(false)
          setDataSaveProgress((prevValues) => ({
            ...prevValues,
            createSchedule: true,
            changePublishStatus: true,
          }));

          let bookingLinkBody = {
            eventId: eventData._id,
          }
          if (request.data.statusCode === 200) {
            let bookingLinkData = request.data.data;
            setDataSaveProgress((prevValues) => ({
              ...prevValues,
              creatingBookingLink: true,
              bookingLink: bookingLinkData.generatedUrl,
            }));
            setNewDraftEventData({})
          }
          // }
          // }
        }

        // }
        // clearFormValues();
        // openSuccessModal();
        return;
      } else if (request.data.statusCode === 403) {
        addErrorToast(request.data.message);
        setSubmitting(false);
        setDataSaveProgress((prevValues) => ({
          ...prevValues,
          isStartSubmiting: false,
          isButtonShow: true,
        }));
      }
    } else {
      setDataSaveProgress((prevValues) => ({
        ...prevValues,
        isStartSubmiting: false,
        isButtonShow: true,
      }));
    }
  };
  const clearFormValues = () => {
    setFormValues(classBodyData);
    setFormScheduleValues({});
  };


  const generalSubmit = async () => {
    setSubmitting(true);

    const errors = {};
    if (!formValues.photo) {
      errors.photo = t("errors.required");
    }
    // if (!Object.keys(formValues.eventCategory).length) {
    //   errors.eventCategory = t("errors.required");
    // }
    // if (!Object.keys(formValues.categories).length) {
    //   errors.categories = t("errors.required");
    // }
    if (!formValues.eventName) {
      errors.eventName = t("errors.required");
    }
    if (!formValues.classDescription) {
      errors.classDescription = t("errors.required");
    } else if (formValues.classDescription.length < 5) {
      errors.classDescription = t("errors.aboutusMinLength", { businessName: title });
    }
    if (!formValues.duration) {
      errors.duration = t("errors.required");
    }
    /// schedule validate
    let startDate = formScheduleValues.startDate?.toDate && typeof formScheduleValues.startDate.toDate == "function" ? formScheduleValues.startDate.toDate() : formScheduleValues.startDate
    let endDate = formScheduleValues.endDate?.toDate && typeof formScheduleValues.endDate.toDate == "function" ? formScheduleValues.endDate.toDate() : formScheduleValues.endDate
    let startTime = formScheduleValues.startTime?.toDate && typeof formScheduleValues.startTime.toDate == "function" ? formScheduleValues.startTime.toDate() : formScheduleValues.startTime
    startTime = moment(moment(startDate).format("YYYY-MM-DD") + " " + moment(startTime).format("HH:mm"), "YYYY-MM-DD HH:mm")
    let endTime = formScheduleValues.endTime?.toDate && typeof formScheduleValues.endTime.toDate == "function" ? formScheduleValues.endTime.toDate() : formScheduleValues.endTime
    let endDateTime = formScheduleValues.endDateTime?.toDate && typeof formScheduleValues.endDateTime.toDate == "function" ? formScheduleValues.endDateTime.toDate() : formScheduleValues.endDateTime
    // endTime = moment(moment().format("YYYY-MM-DD") + "" + moment(endTime).format("HH:mm"), "YYYY-MM-DD HH:mm")
    endTime = moment(moment(endDateTime).format("YYYY-MM-DD") + " " + moment(endTime).format("HH:mm"), "YYYY-MM-DD HH:mm")
    var duration = moment.duration(moment(endTime).diff(moment(startTime)));
    var minutes = duration.asMinutes();
    const durationSplit = formValues.durationstring.split(" ");
    // const durationInNum = Number(durationSplit[0]) * 60 + Number(durationSplit[2]);
    const durationInNum = minutes;
    

    if (formScheduleValues.radioValue2 !== "Custom" && !formScheduleValues.startDate) {
      errors.startDate = t("errors.required");
    }
    if (formScheduleValues.radioValue !== "One Time") {
      if (formScheduleValues.radioValue2 !== "Custom") {
        if (!formScheduleValues.endDate) {
          errors.endDate = t("errors.required");
        }
      }
    }
    if (formScheduleValues.radioValue !== "One Time" && formScheduleValues.radioValue2 !== "Custom") {
      if (formScheduleValues.endDate < formScheduleValues.startDate) {
        errors.endDate = t("errors.endDateErrorMsg");
      }
    }
    if (
      formScheduleValues.radioValue === "Recurrent" &&
      formScheduleValues.radioValue2 !== "Custom"
    ) {
      if (formScheduleValues.endDate < formScheduleValues.startDate) {
        errors.endDate = t("errors.endDateErrorMsg");
      }
    }
    if (!formScheduleValues.startTime) {
      errors.startTime = t("errors.required");
    }
    if (
      formScheduleValues.radioValue2 !== "Custom" &&
      // isBefore(formScheduleValues.startDate, new Date())
      isBefore(formScheduleValues.startDate, moment().subtract(0, "days").toDate())
    ) {
      errors.startDate = t("errors.startDateErrorMsg");
    }
    if (!Object.keys(formScheduleValues.location).length) {
      errors.postalAddress = t("errors.required");
      addErrorToast(t("errors.locationRequiredErrorMsg"));
    }

    if (durationInNum < 1) {
      errors.scheduleError = t("errors.startApartMinuteErrorMsg");
    }

    setFormErrors({ ...errors });
    if (Object.keys(errors).length > 0) {
      setSubmitting(false);
      addErrorToast(t("errors.validationGeneralError"), { hideAfter: 3 });
      return false;
    }

    if (!formValues.whatToCarry) {
      setFormValues((prevValues) => ({
        ...prevValues,
        whatToCarry: "Nothing specified",
      }));
    }


    setFormValues((prevValues) => ({
      ...prevValues,
      duration: durationInNum,
    }));

    setSubmitting(false);
    setTabCurrentState("2");
    return true;
  };


  const scheduleSubmit = () => {
    setSubmitting(true);
    const errors = {};
    if (formScheduleValues.radioValue2 !== "Custom" && !formScheduleValues.startDate) {
      errors.startDate = t("errors.required");
    }
    if (formScheduleValues.radioValue !== "One Time") {
      if (formScheduleValues.radioValue2 !== "Custom") {
        if (!formScheduleValues.endDate) {
          errors.endDate = t("errors.required");
        }
      }
    }
    if (formScheduleValues.radioValue !== "One Time" && formScheduleValues.radioValue2 !== "Custom") {
      if (formScheduleValues.endDate < formScheduleValues.startDate) {
        errors.endDate = t("errors.endDateErrorMsg");
      }
    }
    if (
      formScheduleValues.radioValue === "Recurrent" &&
      formScheduleValues.radioValue2 !== "Custom"
    ) {
      if (formScheduleValues.endDate < formScheduleValues.startDate) {
        errors.endDate = t("errors.endDateErrorMsg");
      }
    }
    if (!formScheduleValues.startTime) {
      errors.startTime = t("errors.required");
    }
    if (
      formScheduleValues.radioValue2 !== "Custom" &&
      // isBefore(formScheduleValues.startDate, new Date())
      isBefore(formScheduleValues.startDate, moment().subtract(0, "days").toDate())
    ) {
      errors.startDate = t("errors.startDateErrorMsg");
    }
    if (!Object.keys(formScheduleValues.location).length) {
      errors.location = t("errors.required");
      addErrorToast(t("errors.locationRequiredErrorMsg"));
    }
    setFormErrors({ ...errors });

    if (Object.keys(errors).length > 0) {
      addErrorToast(t("errors.validationGeneralError"));
      return false;
    }

    let toDays = [];
    let sDays = [];
    let sortedDates = [];
    let dateWithTime = "";
    let startDate = formScheduleValues.startDate?.toDate && typeof formScheduleValues.startDate.toDate == "function" ? formScheduleValues.startDate.toDate() : formScheduleValues.startDate
    let endDate = formScheduleValues.endDate?.toDate && typeof formScheduleValues.endDate.toDate == "function" ? formScheduleValues.endDate.toDate() : formScheduleValues.endDate
    let startTime = formScheduleValues.startTime?.toDate && typeof formScheduleValues.startTime.toDate == "function" ? formScheduleValues.startTime.toDate() : formScheduleValues.startTime
    let endTime = formScheduleValues.endTime?.toDate && typeof formScheduleValues.endTime.toDate == "function" ? formScheduleValues.endTime.toDate() : formScheduleValues.endTime


    let startDateTime =
      formScheduleValues.radioValue2 !== "Custom" &&
      moment(moment(startDate).format("YYYY-MM-DD") + " " + moment(startTime).format("HH:mm"), "YYYY-MM-DD HH:mm");
    // startDateTime = formScheduleValues.radioValue2 !== "Custom" && sub(startDateTime, { months: 1 });
    let endDateTime =
      formScheduleValues.radioValue !== "One Time" &&
      formScheduleValues.radioValue2 !== "Custom" &&
      moment(moment(endDate).format("YYYY-MM-DD") + " " + moment(startTime).format("HH:mm"), "YYYY-MM-DD HH:mm");
    if (
      formScheduleValues.radioValue === "Recurrent" &&
      formScheduleValues.radioValue2 === "Daily"
    ) {
      let current = startDateTime;
      while (current <= endDateTime) {
        toDays.push(current.toISOString());
        // current = addDays(current, 1);
        current = current.add(1, 'Days');
      }
    }
    if (
      formScheduleValues.radioValue === "Recurrent" &&
      formScheduleValues.radioValue2 === "Custom"
    ) {
      sortedDates = [...formScheduleValues.daysInWeek].sort((a, b) => {
        return new Date(a) - new Date(b);
      });
      sortedDates.map((date) =>
        toDays.push(
          set(date, {
            hours: Number(moment(startTime).format("HH")),
            minutes: Number(moment(startTime).format("mm")),
            seconds: 0,
          })
        )
      );
    }
    if (
      formScheduleValues.radioValue === "Recurrent" &&
      formScheduleValues.radioValue2 === "Weekly"
    ) {
      dateWithTime =
        moment(moment(startDate).toDate()).format("YYYY/MM/DD") +
        "," +
        moment(startTime).format("hh") +
        ":" +
        moment(startTime).format("mm") +
        " " +
        moment(startTime).format("a");
      startDateTime = moment(moment(startDate).format("YYYY-MM-DD") + " " + moment(startTime).format("HH:mm"), "YYYY-MM-DD HH:mm");
      endDateTime = moment(moment(endDate).format("YYYY-MM-DD") + " " + moment(startTime).format("HH:mm"), "YYYY-MM-DD HH:mm");
      sDays = [...formScheduleValues.daysInWeek].map((day) => getDay(day));
      sDays = sDays.sort((a, b) => a - b);
    }


    const body = {
      isPublished: false,
      eventId: formValues.id,
      eventName: formValues.eventName,
      eventPricingList: formValues.eventPricingList,
      addonsPricingList: formValues.addonsPricingList,
      startDate:
        formScheduleValues.radioValue === "Recurrent" &&
          formScheduleValues.radioValue2 === "Custom"
          ? toDays[0]
          : formScheduleValues.radioValue2 === "Weekly"
            ? moment(dateWithTime, "YYYY/MM/DD hh:mm a").toISOString()
            : moment(startDate).format("YYYY-MM-DD"),
      timing: moment(startTime).format("hh:mm a"),
      endAfter: "",
      meridiem: moment(startTime).format("A"),
      ...(formScheduleValues.radioValue === "Recurrent"
        ? { recurrenceType: formScheduleValues.radioValue2.toLowerCase() }
        : {}),
      endBy:
        formScheduleValues.radioValue === "Recurrent" &&
          formScheduleValues.radioValue2 === "Daily"
          ? endDateTime
          : formScheduleValues.radioValue2 === "Weekly"
            ? endDateTime
            : formScheduleValues.radioValue2 === "Custom"
              ? toDays[toDays.length - 1]
              : startDateTime,
      utcOffset: new Date().getTimezoneOffset(),
      ...(formScheduleValues.radioValue2 === "Weekly"
        ? { daysInWeek: [], selectedDays: sDays }
        : {
          daysInWeek:
            formScheduleValues.radioValue === "Recurrent" ? toDays : [startDateTime.toDate()],
        }),
      eventStartDateTime:
        formScheduleValues.radioValue === "Recurrent" &&
          formScheduleValues.radioValue2 === "Custom"
          ? toDays[0]
          : startDateTime,
      location: {
        ...formScheduleValues.location,
        locationId: formScheduleValues.location._id,
        address: formScheduleValues.location.address,
        addressName: formScheduleValues.location.addressName,
        houseNumber: formScheduleValues.location.houseNumber,
        city: formScheduleValues.location.city,
        zip: formScheduleValues.location.zip ? formScheduleValues.location.zip : "",
      },
      eventStatus: "Published",
      startTime: formScheduleValues.startTime,
      endDate: formScheduleValues.endDate,
      endDateTime: formScheduleValues.endDateTime,
      endTime: formScheduleValues.endTime,
    };
    // return;
    setFormScheduleValues(body);
    // commented because of merge tab in general
    // }
    scheduleDates();
    return body;
  };

  const scheduleDates = () => {

    let toDays = [];
    let sDays = [];
    let sortedDates = [];
    let dateWithTime = "";
    let startDate = formScheduleValues.startDate?.toDate && typeof formScheduleValues.startDate.toDate == "function" ? formScheduleValues.startDate.toDate() : formScheduleValues.startDate
    let endDate = formScheduleValues.endDate?.toDate && typeof formScheduleValues.endDate.toDate == "function" ? formScheduleValues.endDate.toDate() : formScheduleValues.endDate
    let startTime = formScheduleValues.startTime?.toDate && typeof formScheduleValues.startTime.toDate == "function" ? formScheduleValues.startTime.toDate() : formScheduleValues.startTime
    let endTime = formScheduleValues.endTime?.toDate && typeof formScheduleValues.endTime.toDate == "function" ? formScheduleValues.endTime.toDate() : formScheduleValues.endTime


    let startDateTime =
      formScheduleValues.radioValue2 !== "Custom" &&
      moment(moment(startDate).format("YYYY-MM-DD") + " " + moment(startTime).format("HH:mm"), "YYYY-MM-DD HH:mm");
    // startDateTime = formScheduleValues.radioValue2 !== "Custom" && sub(startDateTime, { months: 1 });
    let endDateTime =
      formScheduleValues.radioValue !== "One Time" &&
      formScheduleValues.radioValue2 !== "Custom" &&
      moment(moment(endDate).format("YYYY-MM-DD") + " " + moment(startTime).format("HH:mm"), "YYYY-MM-DD HH:mm");

    if (
      formScheduleValues.radioValue === "Recurrent" &&
      formScheduleValues.radioValue2 === "Daily"
    ) {
      let current = startDateTime;
      while (current <= endDateTime) {
        toDays.push(current.toISOString());
        // current = addDays(current, 1);
        current = current.add(1, 'Days');
      }
    }
    if (
      formScheduleValues.radioValue === "Recurrent" &&
      formScheduleValues.radioValue2 === "Custom"
    ) {
      sortedDates = [...formScheduleValues.daysInWeek].sort((a, b) => {
        return new Date(a) - new Date(b);
      });
      sortedDates.map((date) =>
        toDays.push(
          set(date, {
            hours: Number(moment(startTime).format("HH")),
            minutes: Number(moment(startTime).format("mm")),
            seconds: 0,
          })
        )
      );
    }
    if (
      formScheduleValues.radioValue === "Recurrent" &&
      formScheduleValues.radioValue2 === "Weekly"
    ) {
      dateWithTime =
        moment(moment(startDate).toDate()).format("YYYY/MM/DD") +
        "," +
        moment(startTime).format("hh") +
        ":" +
        moment(startTime).format("mm") +
        " " +
        moment(startTime).format("a");
      startDateTime = moment(moment(startDate).format("YYYY-MM-DD") + " " + moment(startTime).format("HH:mm"), "YYYY-MM-DD HH:mm");
      endDateTime = moment(moment(endDate).format("YYYY-MM-DD") + " " + moment(startTime).format("HH:mm"), "YYYY-MM-DD HH:mm");
    }

    startDateTime =
      formScheduleValues.radioValue === "Recurrent" &&
        formScheduleValues.radioValue2 === "Custom"
        ? toDays[0]
        : formScheduleValues.radioValue2 === "Weekly"
          ? moment(dateWithTime, "YYYY/MM/DD hh:mm a")
          : startDateTime;


    endDateTime =
      formScheduleValues.radioValue === "Recurrent" &&
        formScheduleValues.radioValue2 === "Daily"
        ? endDateTime
        : formScheduleValues.radioValue2 === "Weekly"
          ? endDateTime
          : formScheduleValues.radioValue2 === "Custom"
            ? toDays[toDays.length - 1]
            : startDateTime;

    let returnVal = {
      startDate, startTime, startDateTime,
      endDateTime, endDate, endTime,
      scheduleStartDateTime: moment(startDateTime).unix(),
      scheduleEndDateTime: moment(endDateTime).unix()
    };
    setScheduleDateTime(returnVal)
    return returnVal;
  };

  React.useEffect(() => {
    setDataSaveProgress(defaultDataSaveProgress);
  }, []);

  React.useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        (async () => {
          const userrequest = await axiosInstance({
            method: "get",
            url: `${getUrlForUsers()}getUserInfo`,
          });
          if (userrequest.data.statusCode === 200) {
            dispatch(userActions.setUserData({
              // ...userReduxState.userData,
              appUrl: userReduxState.userData.appUrl,
              ...userrequest.data.data,
            }));
          }
        })();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  //   })
  // }, [formValues, formScheduleValues]);

  return (
    <TwMainLayout
      headTitle={t("pageTitle.addNewEvent")}
      children={
        <TwContainer className="">
          <TwTabContainer
            className=""
            tabsClassName={classNames("border-b px-5 md:px-10", dataSaveProgress.isButtonShow === true ? "" : "hidden")}
            selectedTab={tabCurrentState}
            allowTabclick={false}
            // setSelectedTab={setTabCurrentState}
            tabs={[
              {
                name: t("myEvents.general"), key: '1', onClick: () => { }, icon: null,
              },
              {
                name: t("myEvents.tickets"), key: '2', onClick: () => { }, icon: null,
              },
              {
                name: t("myEvents.addons"), key: '3', onClick: () => { }, icon: null,
              },
              {
                name: t("myEvents.eventSettings"), key: '4', onClick: () => { }, icon: null,
              },
              {
                name: t("myEvents.reviewPublish"), key: '6', onClick: () => { }, icon: null,
              },
            ]}
          >
            <TabPanel key={"1"}>
              <div className="flex flex-col gap-4">
                <div className="p-5 flex flex-col [sm:flex-row] gap-4">
                  <GeneralTab
                    profileFor={profileFor}
                    title={title}
                    edit={false}
                    formValues={formValues}
                    setFormValues={setFormValues}
                    formValidationErrors={formErrors}
                    setTabCurrentState={setTabCurrentState}
                    handleCancel={() => {
                      dispatch(dashboardActions.setCalendarSessionId(-1));
                      dispatch(dashboardActions.setCalendarOpen(false));
                      navigate("/home/dashboard");
                    }}
                  />
                  <ScheduleTab
                    duration={formValues.duration}
                    classObj={formValues}
                    eventFormValues={formValues}
                    setEventFormValues={setFormValues}
                    formEventErrors={formErrors}
                    formScheduleValues={formScheduleValues}
                    // handleFormValueChange={handleFormValueChange}
                    setFormScheduleValues={setFormScheduleValues}
                    setTabCurrentState={setTabCurrentState}
                    defaultDataSaveProgress={defaultDataSaveProgress}
                    dataSaveProgress={dataSaveProgress}
                    setDataSaveProgress={setDataSaveProgress}
                    defaultScheduleData={defaultScheduleData}
                    setDefaultScheduleData={setDefaultScheduleData}
                  />
                </div>
                <div className={"flex gap-4 justify-center [pt-5] [w-full [sm:w-full sm:max-w-sm] md:max-w-lg]"}>
                  <TwButton
                    variant={"secondary-outline"}
                    className={"w-full sm:w-60"}
                    onClick={() => {
                      dispatch(dashboardActions.setCalendarSessionId(-1));
                      dispatch(dashboardActions.setCalendarOpen(false));
                      navigate("/myschedule");
                    }}
                  >
                    {t("inputFieldsTitle.cancel")}
                  </TwButton>
                  <TwButton
                    variant={"secondary"}
                    className={"w-full sm:w-60"}
                    disabled={loadingReduxState.actionLoading}
                    actionLoading={(loadingReduxState.actionLoading)}
                    onClick={() => {
                      let validSchedule = scheduleSubmit()
                      let validGeneral = generalSubmit()
                      if (validSchedule !== false && validGeneral !== false) {
                        setShouldBlock(true)
                      }
                      scheduleDates()
                      // }
                    }}
                  >
                    {/* {edit && edit != "duplicateEvent" ? t("update") : t("inputFieldsTitle.continue")} */}
                    {t("inputFieldsTitle.continue")}
                  </TwButton>
                </div>
              </div>
            </TabPanel>
            <TabPanel key={"2"}>
              <div className="">
                <PricingTab
                  profileFor={profileFor}
                  formValues={formValues}
                  setFormValues={setFormValues}
                  setTabCurrentState={setTabCurrentState}
                  scheduleCreatAtDateTime={moment().unix()}
                  scheduleStartDateTime={scheduleDateTime.scheduleStartDateTime}
                  scheduleEndDateTime={scheduleDateTime.scheduleEndDateTime}
                />
              </div>
            </TabPanel>
            <TabPanel key={"3"}>
              <div className="">
                <AddonsTab
                  profileFor={profileFor}
                  formValues={formValues}
                  setFormValues={setFormValues}
                  setTabCurrentState={setTabCurrentState}
                />
              </div>
            </TabPanel>
            <TabPanel key={"4"}>
              <div className="p-5">
                <PoliciesTab
                  formErrors={formErrors}
                  formValues={formValues}
                  handleFormValueChange={handleFormValueChange}
                  setFormValues={setFormValues}
                  setTabCurrentState={setTabCurrentState}
                  payment={payment}
                  handleCancel={() => {
                    setTabCurrentState("3");
                  }}
                />
              </div>
            </TabPanel>
            {/* <TabPanel key={"5"}>
              <div className="">
                <ScheduleTab
                  duration={formValues.duration}
                  classObj={formValues}
                  eventFormValues={formValues}
                  setEventFormValues={setFormValues}
                  formEventErrors={formErrors}
                  formScheduleValues={formScheduleValues}
                  // handleFormValueChange={handleFormValueChange}
                  setFormScheduleValues={setFormScheduleValues}
                  setTabCurrentState={setTabCurrentState}
                  defaultDataSaveProgress={defaultDataSaveProgress}
                  dataSaveProgress={dataSaveProgress}
                  setDataSaveProgress={setDataSaveProgress}
                  defaultScheduleData={defaultScheduleData}
                  setDefaultScheduleData={setDefaultScheduleData}
                />
              </div>
            </TabPanel> */}
            <TabPanel key={"6"}>
              <div className="">
                <ReviewPublishTab
                  formValues={formValues}
                  formScheduleValues={formScheduleValues}
                  handleFormValueChange={handleFormValueChange}
                  setTabCurrentState={setTabCurrentState}
                  defaultDataSaveProgress={defaultDataSaveProgress}
                  dataSaveProgress={dataSaveProgress}
                  setDataSaveProgress={setDataSaveProgress}
                />
                {dataSaveProgress.isButtonShow === true ? (
                  <div className={"flex gap-2 justify-center pt-5 sm:px-8 max-w-4xl"}>
                    <TwButton
                      variant={"secondary-outline"}
                      className={"w-full sm:w-1/3"}
                      onClick={() => {
                        setTabCurrentState("4");
                      }}
                    >
                      {t("inputFieldsTitle.back")}
                    </TwButton>
                    <TwButton
                      variant={"primary-outline"}
                      className={"w-full sm:w-1/3 truncate"}
                      actionLoading={(loadingReduxState.actionLoading)}
                      // disabled={isSubmitting}
                      onClick={() => {
                        saveClass(false);
                      }}
                    >
                      {t("myEvents.exitCreateNewEventBtn")}
                    </TwButton>
                    <TwButton
                      variant={"secondary"}
                      className={"w-full sm:w-1/3 truncate"}
                      actionLoading={(loadingReduxState.actionLoading)}
                      // disabled={isSubmitting}
                      onClick={() => {
                        saveClass(true);
                      }}
                    >
                      {t("myEvents.createPublish")}
                    </TwButton>
                  </div>
                ) : ""}
              </div>
            </TabPanel>
          </TwTabContainer>
          <TwNavigationGuard
            dialogTitle={t("myEvents.exitCreateNewEvent")}
            dialogMessage={t("myEvents.exitCreateNewEventSubTitle")}
            btnSubmitText={t("myEvents.exitCreateNewEventBtn")}
            btnCloseText={t("myEvents.exitCreateNewEventDiscardBtn")}
            when={() => shouldBlock}
            onConfirm={async () => {
              dispatch(setGlobalLoading(true));
              await saveClass(false);
              dispatch(setGlobalLoading(false));
            }}
            onClose={() => { console.log("onClose"); return true; }}
          />
        </TwContainer>} />
  );
}
